
const MAX_FILE_COUNT = 3;
const MAX_TOTAL_FILE_SIZE = 5 * 1024 * 1024; // 5 MB total (alineado con GenerarTicket.js)
const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png", "image/gif"];

function appendEmptyArchivoPart(formData) {
    formData.append(
        "archivos",
        new Blob([], { type: "application/octet-stream" }),
        "empty.txt"
    );
}

export function buildNuevoTicket(ticket, tipoOperacion, captchaResponse) {
    const formData = new FormData();

    const ticketData = {
        nombre: ticket.nombre,
        email: ticket.email,
        mailConfirmacion: ticket.mailConfirmacion,
        telefono: ticket.telefono,
        dominio: ticket.dominio,
        asunto: ticket.asunto,
        mensaje: ticket.mensaje,
        captchaResponse: captchaResponse,
    };

    formData.append(
        "datosTicket",
        new Blob(
            [
                JSON.stringify({
                    ticket: ticketData,
                    tiposOperacion: tipoOperacion,
                    captcha: captchaResponse,
                }),
            ],
            { type: "application/json" }
        )
    );

    formData.append("tipoOperacion", tipoOperacion);
    formData.append("captcha", captchaResponse);

    const archivos = ticket.archivos && ticket.archivos.length > 0 ? ticket.archivos : [];

    if (archivos.length === 0) {
        appendEmptyArchivoPart(formData);
        return formData;
    }

    if (archivos.length > MAX_FILE_COUNT) {
        throw new Error(`No se pueden adjuntar más de ${MAX_FILE_COUNT} archivos.`);
    }

    let totalSize = 0;
    let appended = 0;

    for (const archivo of archivos) {
        if (!ALLOWED_FILE_TYPES.includes(archivo.type)) {
            throw new Error(`Formato no permitido: ${archivo.name}`);
        }
        totalSize += archivo.size;
        if (totalSize > MAX_TOTAL_FILE_SIZE) {
            throw new Error(
                `El tamaño total de los archivos supera el límite permitido de ${(MAX_TOTAL_FILE_SIZE / (1024 * 1024)).toFixed(2)} MB.`
            );
        }
        formData.append("archivos", archivo);
        appended++;
    }

    if (appended === 0) {
        console.error("Hay archivos en el formulario pero ninguno se agregó al request.");
        throw new Error("No se pudieron adjuntar los archivos seleccionados. Verifique formato y tamaño.");
    }

    return formData;
}
